<template>
  <div>
    <!-- {{ info }} -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('device', ['info']),
  },
  watch: {
    async info(v) {
      if (v) {
        await this.saveFcm()
      }
    },
  },
  async created() {
    await this.saveFcm()
  },
  methods: {
    ...mapActions('device', ['saveFcm']),
  },
}
</script>
